import { Component, OnInit } from '@angular/core';
import { ProfileSearchResult } from '../../data/ProfileSearchResult';
import { CardholderService } from '../../services/cardholder.service';
import { EntitlementService } from '../../services/entitlement.service';
import { CardholderDetails } from '../../data/CardholderDetails';
import { CustomerAccount } from '../../data/CustomerAccount';
import { Identity } from '../../Identity';
import { Card } from '../../data/Card';
import { MessageService } from '../../services/message.service';
import {
  UntypedFormBuilder,
  UntypedFormGroup
} from '@angular/forms';
import { Ship } from 'src/app/Ship';

@Component({
  selector: 'app-cardholder-visaforward',
  templateUrl: './cardholder-visaforward.component.html',
  styleUrl: './cardholder-visaforward.component.css'
})
export class CardholderVisaforwardComponent implements OnInit {
  cardholder: ProfileSearchResult;
  cardsForm: UntypedFormGroup;
  identity: Identity;
  profiles: Ship[] = [];
  cardsAccounts: Card[];
  meus: any[] = [];
  chipOnly: boolean;
  cardSeq: number = null;
  cardholderDetails: CardholderDetails;
  stripAccount: CustomerAccount;
  chipsAccount: CustomerAccount[];
  isEscrow: boolean;
  customerAccount: CustomerAccount;
  customerAccounts: CustomerAccount[];
  originalCardStatuses: string[] = [];
  originalChipStatuses: string[] = [];
  originalChipLimit: number[] = [];
  selectedCardDetails: any;
  isLoaded: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private entitlementService: EntitlementService,
    private messageService: MessageService,
    private cardHolderService: CardholderService

  ) {}

  ngOnInit() {
    this.cardholder = CardholderService.retrieveCardholder();
    console.log(this.cardholder);
    this.loadCardHolderDetails();
  }

  showNewCardholder(newCardholder: ProfileSearchResult) {
    CardholderService.storeCardHolder(newCardholder);
    this.cardholder = newCardholder;
    this.loadCardHolderDetails();
  }

  loadCardHolderDetails() {
  this.cardHolderService
    .getCardholderDetails(this.cardholder.payrollAccount)
    .subscribe(
      (data: CardholderDetails) => {
        console.log(data);
        this.cardSeq = data.cardList[0].cardSeq;
        this.cardholderDetails = data;
        this.stripAccount = data.customerAccounts[0];
        this.chipsAccount = data.customerAccounts.slice(
          1,
          data.customerAccounts.length
        );
        this.identity = data.identity;
        this.isEscrow = data.escrow;
        this.customerAccount = data.customerAccounts[0]; // Payroll Account/Strip Account
        this.customerAccounts = data.customerAccounts;
        this.cardsAccounts = data.cardList;
        console.log(this.cardsAccounts[0].cardSeq);
        (<UntypedFormGroup>this.cardsForm).patchValue(
          { cardsAccount: this.cardsAccounts[0].cardSeq }
        );

        // Call getCardDetails()
        this.cardHolderService
          .getCardDetails(this.cardsAccounts[0].cardSeq)
          .subscribe(
            (data: String) => {
              this.selectedCardDetails = JSON.stringify(data, null, 4);
            },
            error => {
              this.messageService.error(
                'There was an error getting the card details '
              );
            }
          )

      },
      error => {
        this.messageService.error(
          'There was an error getting the card holder details ' + error.data
        );
      },
      () => {
        this.fixChipStatus();
        this.checkChipOnly();
        this.cardHolderService.chipDetails(this.chipOnly);
      }
    );
    this.initForms();
  }

  initForms() {
    this.cardsForm = this.formBuilder.group({
      cardsAccount: ['', []]
    });

  }

  loadFormData() {
    console.log(this.cardsAccounts[0].cardSeq);
    this.cardsForm.patchValue(
      { cardsAccount: this.cardsAccounts[0].cardSeq }
    );
  }

  checkChipOnly() {
    const index = this.cardsAccounts.findIndex((x) => x.type !== 'CHIP');
    this.chipOnly = index < 0;
  }

  fixChipStatus() {
    for(let i : number = 0; i < this.originalCardStatuses.length; i++)
    {
      if (this.originalCardStatuses[i] == 'ACTIVE')
      {
        continue;
      }
      if (this.originalCardStatuses[i] == 'STOLEN' || this.originalCardStatuses[i] == 'LOST' || this.originalCardStatuses[i] == 'DAMAGED' || this.originalCardStatuses[i] == 'CANCELLED') {
        this.chipsAccount[i].status = 'CLOSED';
        this.originalChipStatuses[i] = 'CLOSED';
      }
    }
  }

  fixStatuses() {
    if (this.originalCardStatuses.length > this.cardsAccounts.length) {
      while (this.originalCardStatuses.length > this.cardsAccounts.length) {
        this.originalCardStatuses.shift();
        this.originalChipStatuses.shift();
        this.originalChipLimit.shift();
      }
    }
  }

  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  cardChanged(newValue) {
    if (this.isLoaded) {
      console.log(newValue);
      this.cardHolderService
        .getCardDetails(newValue)
        .subscribe(
          (data: String) => {
            this.selectedCardDetails = JSON.stringify(data, null, 4);
          },
          error => {
            this.messageService.error(
              'There was an error getting the card details '
            );
          }
        )
    }
    else {
      this.isLoaded = true;
    }
  }
}
